import { useState } from "react";

import { LatestServicesPreview } from "./components";

import {
  Card,
  Text,
  Header,
  Button,
  CarInfo,
  SelectCarPop,
  QuickAccess,
} from "../../Components/Index";
import {
  ProfileIcon,
  RegisterServiceIcon,
  CarsIcon,
} from "../../Components/BottomNavigation/BottomNavigation";

import { useCars } from "../../Context/CarContext";
import "./customerDashbord.scss";

function CustomerDashbord() {
  const [isSelectCarPopOpen, setIsSelectCarPopOpen] = useState(false);

  const { getSelectedCar, selectCar } = useCars();

  const selectedCar = getSelectedCar();

  const handleCarSelect = (carId) => {
    selectCar(carId);
  };

  const handleOpenSelectCarPop = () => {
    setIsSelectCarPopOpen(true);
  };

  const handleCloseSelectCarPop = () => {
    setIsSelectCarPopOpen(false);
  };

  const handleConfirmCarSelection = (carId) => {
    handleCarSelect(carId);
    handleCloseSelectCarPop();
  };

  return (
    <main className="customer-dashboard" dir="rtl">
      <Header Text="داشبورد مشتری" />

      <div className="customer-dashboard__content">
        {/* اطلاعات ماشین */}
        {selectedCar ? (
          <CarInfo
            Src={selectedCar.Src}
            Plate1={selectedCar.Plate1}
            Plate2={selectedCar.Plate2}
            Plate3={selectedCar.Plate3}
            End={selectedCar.End}
            Km={selectedCar.Km}
            CarModel={selectedCar.CarModel}
            ProductionYear={selectedCar.ProductionYear}
            CarColor={selectedCar.CarColor}
            onSelect={handleOpenSelectCarPop}
            hideSelectionUI
          />
        ) : (
          <Card className="CustomerDashboard__empty">
            <Text FontWight="Bold" position="center">
              خودرویی انتخاب نشده است
            </Text>

            <Button onClick={handleOpenSelectCarPop}>
              انتخاب خودرو
            </Button>
          </Card>
        )}

        {/* دسترسی سریع */}
        <QuickAccess
          title="دسترسی سریع"
          items={[
            { to: "/UserPanel", label: "پنل کاربری", Icon: ProfileIcon },
            { to: "/SelectService", label: "ثبت سرویس", Icon: RegisterServiceIcon },
            { to: "/Cars", label: "ماشین‌ها", Icon: CarsIcon },
          ]}
        />

        {/* سرویس های رو به پایان */}
        <LatestServicesPreview limit={3} />
      </div>

      {/* انتخاب خودرو */}
      <SelectCarPop
        isOpen={isSelectCarPopOpen}
        onClose={handleCloseSelectCarPop}
        onConfirm={handleConfirmCarSelection}
      />
    </main>
  );
}

export default CustomerDashbord;
